import { useAuthorization } from "~/contexts/authorizationProvider";
import { LedgerTransactionPermission, type RBACPermission } from "~/shared/types/RBACPermission";

/** Matches `rbacPermissionProcedure` on ledger-backed read surfaces (e.g. Purchases Clearing, Transactions). */
export const ledgerTransactionViewPermissions: RBACPermission[] = [LedgerTransactionPermission.view];

export const useCanViewLedgerTransactions = (): boolean => {
  const { hasPermission } = useAuthorization();
  return hasPermission(ledgerTransactionViewPermissions);
};
